/**
 * defaultTemplateOptions.
 * @remarks
 * The default template options this MF has been created with.
 * @public
 */
export const defaultTemplateOptions = {
    icon: 'zero-icon',
    button: 'zero-button',
    connectionIndicator: 'zero-connection-indicator',
    select: 'zero-select',
    option: 'zero-option',
    flyout: 'zero-flyout',
    provider: 'zero-design-system-provider',
};
